import {
  Box,
  Button,
  ButtonProps,
  GridColumn,
  GridSizeProp,
  Icon,
  IconNameType,
  Target,
  Text
} from "@modernatx/ui-kit-react";
import React from "react";

export interface UtilityCardProps {
  image?: string;
  icon?: IconNameType;
  header?: string;
  description?: string;
  actions?: ButtonProps[];
  size?: GridSizeProp;
  onClick?: (e: React.MouseEvent) => void;
}

export const UtilityCard: React.FC<UtilityCardProps> = ({
  image,
  icon,
  header,
  description,
  actions,
  size = 4,
  onClick
}) => {
  return (
    <GridColumn
      size={size}
      sx={{
        backgroundColor: "white",
        outline: "1px solid",
        outlineColor: "stroke-neutral-secondary",
        borderRadius: "radius-2",
        boxShadow: "shadow-200",
        my: ["spacing-none", "spacing-4", null]
      }}
    >
      <Target onClick={onClick} sx={{ flex: 1 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "spacing-7",
            gap: "spacing-4",
            height: "100%"
          }}
        >
          {image ? (
            <Box
              as="img"
              src={image}
              sx={{ height: "spacing-10", width: "spacing-10" }}
            />
          ) : icon ? (
            <Icon icon={icon} size="lg" sx={{ alignSelf: "flex-start" }} />
          ) : null}

          {header && <Text variant="title-1-medium">{header}</Text>}
          {description && <Text variant="body-1-regular">{description}</Text>}

          <Box sx={{ flex: 1 }} />
          {actions && (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: "spacing-3"
              }}
            >
              {actions.map((button, index) => (
                <Button key={index} {...button} />
              ))}
            </Box>
          )}
        </Box>
      </Target>
    </GridColumn>
  );
};
